export const SET_VIDEO_STORE = 'SET_VIDEO_STORE';
export const GET_VIDEO_STORE = 'GET_VIDEO_STORE';
export const REMOVE_VIDEO_STORE = 'REMOVE_VIDEO_STORE';
